let request;
let hbr_db;
let version = 9;

export const initDB=()=>{
    return new Promise((resolve,reject)=>{
        request = indexedDB.open("hbrDatabase",version);
        request.onsuccess=(event)=>{
            try{
                hbr_db = event.target.result;
                version = hbr_db.version;
                resolve(true);
            }catch(error){
                console.log(error);
            }
        };
        request.onupgradeneeded=(event)=>{
            hbr_db = event.target.result;
            if (!hbr_db.objectStoreNames.contains("hbrvideostore")) {
                hbr_db.createObjectStore("hbrvideostore",{keyPath:'id'});
            }   
              if (!hbr_db.objectStoreNames.contains("hbrvideowatchlist")) {
              let store = hbr_db.createObjectStore("hbrvideowatchlist",{keyPath:'id'});
               store.createIndex("year","year",{unique:false});
              } 
              if (hbr_db.objectStoreNames.contains("hbrchatroom")) {
                hbr_db.deleteObjectStore("hbrchatroom");
              }
              if (!hbr_db.objectStoreNames.contains("hbrbooks")) {
                hbr_db.createObjectStore("hbrbooks",{keyPath:'id'});
              }
              if (!hbr_db.objectStoreNames.contains("hbrsavedblogs")) {
                hbr_db.createObjectStore("hbrsavedblogs",{keyPath:'id'});
              } 
              if (!hbr_db.objectStoreNames.contains("hbredified")) {
                hbr_db.createObjectStore("hbredified",{keyPath:'id'});
              } 
              if (!hbr_db.objectStoreNames.contains("hbrviews")) {
                hbr_db.createObjectStore("hbrviews",{keyPath:'id'});
              } 

              if (!hbr_db.objectStoreNames.contains("hbrlastreadpage")) {
                hbr_db.createObjectStore("hbrlastreadpage",{keyPath:'id'});
              }
              if (!hbr_db.objectStoreNames.contains("hbraudiobooks")) {
                hbr_db.createObjectStore("hbraudiobooks",{keyPath:'id'});
              }       
              if (hbr_db.objectStoreNames.contains("hbrwallpaperstore")) {
                hbr_db.deleteObjectStore("hbrwallpaperstore",{keyPath:'id'});
              }   
              if (!hbr_db.objectStoreNames.contains("hbrmessagegenre")) {
                hbr_db.createObjectStore("hbrmessagegenre",{keyPath:'id'});
              }    
        }
        request.onerror=(event)=>{
            reject(`Error opening indexedDB:${event.target.error}`)
        };
    });
};

export const storeMessageGenreToLocalDB=(data)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbrmessagegenre"],'readwrite');
        const objectStore = transaction.objectStore("hbrmessagegenre");
        const request = objectStore.put(data);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error storing message genre: ${event.target.error}`);
        };
    });
}
export const getMessageGenres=()=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbrmessagegenre"]);
        const objectStore = transaction.objectStore("hbrmessagegenre");
        const request = objectStore.getAll();

        request.onsuccess=(event)=>{
            resolve(request.result);
        };
        request.onerror=(event)=>{
            reject(`Error getting message genres: ${event.target.error}`);
        };
    });
};

export const deleteWallpaper=(id)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbrwallpaperstore"],'readwrite');
        const objectStore = transaction.objectStore("hbrwallpaperstore");
        const request = objectStore.delete(id);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error deleting wallpaper: ${event.target.error}`);
        };
    });
};
export const storeWallpaperSelected=(data)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbrwallpaperstore"],'readwrite');
        const objectStore = transaction.objectStore("hbrwallpaperstore");
        const request = objectStore.put(data);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error getting wallpaper: ${event.target.error}`);
        };
    });
};

export const getWallpapers=()=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbrwallpaperstore"]);
        const objectStore = transaction.objectStore("hbrwallpaperstore");
        const request = objectStore.getAll();

        request.onsuccess=(event)=>{
            resolve(request.result);
        };
        request.onerror=(event)=>{
            reject(`Error getting short views: ${event.target.error}`);
        };
    });
};

export const trackshortViewsDB=(data)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbrviews"],'readwrite');
        const objectStore = transaction.objectStore("hbrviews");
        const request = objectStore.put(data);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error tracking short views: ${event.target.error}`);
        };
    });
};

export const getViewsDB=(id)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbrviews"]);
        const objectStore = transaction.objectStore("hbrviews");
        const request = objectStore.get(id);
        request.onsuccess=(event)=>{
            resolve(request.result);
        };
        request.onerror=(event)=>{
            reject(`Error getting short views: ${event.target.error}`);
        };
    });
};


export const trackEdifiedStateDB=(data)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbredified"],'readwrite');
        const objectStore = transaction.objectStore("hbredified");
        const request = objectStore.put(data);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error tracking edified state: ${event.target.error}`);
        };
    });
};
export const deleteEdifiedData=(id)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbredified"],'readwrite');
        const objectStore = transaction.objectStore("hbredified");
        const request = objectStore.delete(id);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error removing edified data: ${event.target.error}`);
        };
    });
};

export const getEdifiedStateDB=(id)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbredified"]);
        const objectStore = transaction.objectStore("hbredified");
        const request = objectStore.get(id);

        request.onsuccess=(event)=>{
            resolve(request.result);
        };
        request.onerror=(event)=>{
            reject(`Error getting edified state: ${event.target.error}`);
        };
    });
};

export const saveAudioBookTime=(data)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbraudiobooks"],'readwrite');
        const objectStore = transaction.objectStore("hbraudiobooks");
        const request = objectStore.put(data);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error saving audio book time to database: ${event.target.error}`);
        };
    });
};

export const getAudioBookLastTime=(id)=>{
    return new Promise((resolve,reject) =>{
        const transaction = hbr_db.transaction(['hbraudiobooks']);
         const objectStore = transaction.objectStore("hbraudiobooks");
        const request = objectStore.get(id);
        request.onsuccess =(event)=>{
            resolve(request.result);
        };
        request.onerror =(event)=>{
            reject(`Error getting audio book time: ${event.target.error}`);
        };
    });
};

export const addBooksToDB=(data)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbrbooks"],'readwrite');
        const objectStore = transaction.objectStore("hbrbooks");
        const request = objectStore.put(data);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error adding books to database: ${event.target.error}`);
        };
    });
};
export const getMySavedBooks=()=>{
    return new Promise((resolve,reject) =>{
        const transaction = hbr_db.transaction(["hbrbooks"],"readonly");
        const objectStore = transaction.objectStore("hbrbooks");
        const request = objectStore.getAll();
        request.onsuccess =()=>{
            resolve(request.result);
        };
        request.onerror =(event)=>{
            reject(`Error getting saved books: ${event.target.error}`);
        };
    });
};
export const getSingleBook=(id)=>{
    return new Promise((resolve,reject) =>{
        const transaction = hbr_db.transaction(['hbrbooks']);
         const objectStore = transaction.objectStore("hbrbooks");
        const request = objectStore.get(id);
        request.onsuccess =(event)=>{
            resolve(request.result);
        };
        request.onerror =(event)=>{
            reject(`Error getting saved book: ${event.target.error}`);
        };
    });
};
export const saveLastReadingPage=(data)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbrlastreadpage"],'readwrite');
        const objectStore = transaction.objectStore("hbrlastreadpage");
        const request = objectStore.put(data);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error saving last read page: ${event.target.error}`);
        };
    });
}
export const getLastReadingPage=(id)=>{
    return new Promise((resolve,reject) =>{
        const transaction = hbr_db.transaction(['hbrlastreadpage']);
         const objectStore = transaction.objectStore("hbrlastreadpage");
        const request = objectStore.get(id);
        request.onsuccess =(event)=>{
            resolve(request.result);
        };
        request.onerror =(event)=>{
            reject(`Error getting last saved page: ${event.target.error}`);
        };
    });
}
export const addBlogsToDB=(data)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbrsavedblogs"],'readwrite');
        const objectStore = transaction.objectStore("hbrsavedblogs");
        const request = objectStore.put(data);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error adding Blog post to database: ${event.target.error}`);
        };
    });
};
export const getMySavedPosts=()=>{
    return new Promise((resolve,reject) =>{
        const transaction = hbr_db.transaction(["hbrsavedblogs"],"readonly");
        const objectStore = transaction.objectStore("hbrsavedblogs");
        const request = objectStore.getAll();
        request.onsuccess =()=>{
            resolve(request.result);
        };
        request.onerror =(event)=>{
            reject(`Error getting saved Posts: ${event.target.error}`);
        };
    });
};
export const addVideoToDB=(data)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbrvideostore"],'readwrite');
        const objectStore = transaction.objectStore("hbrvideostore");
        const request = objectStore.put(data);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error adding video to database: ${event.target.error}`);
        };
    });
};
export const getSavedVideo=(id)=>{
    return new Promise((resolve,reject) => {
        const transaction = hbr_db.transaction(['hbrvideostore']);
        const objectStore = transaction.objectStore('hbrvideostore');
        const request = objectStore.get(id);

        request.onsuccess = (event)=>{
            resolve(request.result);
        };
        request.onerror = (event) => {
            reject(`Error getting saved videos: ${event.target.error}`);
        };
    });
};
export const addToWatchList=(data)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hbrvideowatchlist"],'readwrite');
        const objectStore = transaction.objectStore("hbrvideowatchlist");
        const request = objectStore.put(data);
        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error adding video to watchlist: ${event.target.error}`);
        };
    });
};
export const getWatchList=(id)=>{
    return new Promise((resolve,reject) => {
        const transaction = hbr_db.transaction(["hbrvideowatchlist"]);
        const objectStore = transaction.objectStore("hbrvideowatchlist");
        const request = objectStore.get(id);
        request.onsuccess = (event)=>{
            resolve(request.result);
        };
        request.onerror = (event) => {
            reject(`Error getting watchlist videos: ${event.target.error}`);
        };
    });
};

export const myWatchList=(year)=>{
    return new Promise((resolve,reject) =>{
        const transaction = hbr_db.transaction(["hbrvideowatchlist"],"readonly");
        const objectStore = transaction.objectStore("hbrvideowatchlist");
        const yearIndex = objectStore.index("year");
        const yearKeyRange = IDBKeyRange.only(`${year}`);
        const request = yearIndex.getAll(yearKeyRange);
        request.onsuccess =()=>{
            resolve(request.result);
        };
        request.onerror =(event)=>{
            reject(`Error getting watchlist videos: ${event.target.error}`);
        };
    });
};
export const mySavedVideos=()=>{
    return new Promise((resolve,reject) =>{
        const transaction = hbr_db.transaction(["hbrvideostore"],"readonly");
        const objectStore = transaction.objectStore("hbrvideostore");
        const request = objectStore.getAll();
        request.onsuccess =()=>{
            resolve(request.result);
        };
        request.onerror =(event)=>{
            reject(`Error getting saved videos: ${event.target.error}`);
        };
    });
};